import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SupplierRegistrationServiceService {

  url = environment.serverAPI4+ "/api/ig/supplierRegister";

  url1 = environment.serverAPI4 + "/api/supplierRegister"; 

  constructor(private http: HttpClient) {
  }


  submitSupplier(supplier:any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, supplier);
  }


}
